
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`
module.exports = require("../lib-vendor/d3-scale/src/index.js");



//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib/d3-scale.js
// module id = 6905
// module chunks = 0